import { App } from 'antd';
import { useMemo } from 'react';
import { createNotifier } from '@/utils/notify';

export function useNotify() {
  const { notification } = App.useApp();
  return useMemo(() => createNotifier(notification), [notification]);
}
